"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createTheme;

var _styles = require("@material-ui/core/styles");

var _merge = _interopRequireDefault(require("lodash/merge"));

/**
 * Creates the default theme for your React Storefront app.  See Material UI's theme documentation
 * for more info: https://material-ui.com/customization/default-theme/
 * @param {Object} values
 * @return {Object} A material UI theme
 */
function createTheme() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var theme = (0, _styles.createMuiTheme)((0, _merge["default"])({}, {
    zIndex: {
      modal: 999,
      amp: {
        modal: 2147483646
      }
    },
    headerHeight: 64,
    loadMaskOffsetTop: 64 + 56 + 4,
    drawerWidth: 330,
    overrides: {}
  }, values));

  if (!theme.maxWidth) {
    theme.maxWidth = "".concat(theme.breakpoints.values.lg, "px");
  }

  return theme;
}
